import { ref, watch, computed } from '@vue/composition-api'
import axios from 'axios'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getToken } from '@/auth/utils'

export default function useCertificatesList() {
  const toast = useToast()
  const refCertificatesListTable = ref(null)

  const tableColumns = [
    { key: 'job_number', label: 'Job Number', sortable: true },
    { key: 'document', label: 'Document', sortable: true },
    { key: 'FullName', label: 'Issued By', sortable: true },
    { key: 'created_at', label: 'Issued At', sortable: true },
    { key: 'actions', label: 'Actions' },
  ]

  const perPage = ref(10)
  const perPageOptions = [10, 20, 50, 100]
  const totalCertificates = ref(0)
  const currentPage = ref(1)
  const searchQuery = ref('')
  const sortBy = ref('created_at')
  const isSortDirDesc = ref(true)

  let searchDebounce = null

  const dataMeta = computed(() => {
    const localItemsCount = refCertificatesListTable.value ? refCertificatesListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalCertificates.value,
    }
  })

  const refetchData = () => {
    refCertificatesListTable.value.refresh()
  }

  watch([currentPage, perPage], () => {
    refetchData()
  })

  watch(searchQuery, () => {
    currentPage.value = 1
    if (searchDebounce) clearTimeout(searchDebounce)
    searchDebounce = setTimeout(() => {
      refetchData()
    }, 400)
  })

  const fetchCertificates = (ctx, callback) => {
    const userToken = getToken()
    const headers = {
      'Content-Type': 'application/json',
      'X-Token-Access': `Bearer ${userToken}`,
    }

    axios
      .get('https://api.geolims.com/invoice_service/getCertificateList', {
        headers,
        params: {
          page: currentPage.value,
          perPage: perPage.value,
          search: searchQuery.value,
        },
      })
      .then(response => {
        const { Certificates, Total } = response.data
        totalCertificates.value = Total !== undefined ? Total : Certificates.length
        callback(Certificates)
      })
      .catch(error => {
        console.log(error)
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching certificate list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  return {
    fetchCertificates,
    tableColumns,
    perPage,
    perPageOptions,
    currentPage,
    totalCertificates,
    dataMeta,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refCertificatesListTable,
    refetchData,
  }
}
